'use client'

import React, { useCallback, useMemo, useRef } from 'react'
import { CrawlerForm, CrawlerFormRef } from '@/modules/crawler/form'
import { Header } from '@/modules/crawler'
//
import { cn } from '@/lib/utils'
import { appSelectors, MessageSeverity, useAppStore } from '@/store'
import { CrawlerFormSchemaType } from './form/CrawlerForm.schema'
import { Else, If, Then } from 'react-if'
import { Redirect } from '@/components'
import { ClientRoutes } from '@/config'
import { useTranslations } from 'next-intl'

export const Main: React.FC = () => {
  const formRef = useRef<CrawlerFormRef>(null)
  const asyncActions = useAppStore(appSelectors.asyncActions)
  const actions = useAppStore(appSelectors.actions)
  const processes = useAppStore(appSelectors.processes)
  const status = useAppStore(appSelectors.status)
  const t = useTranslations('crawler.form')
  const locale = useAppStore(appSelectors.locale)

  const onSubmit = useCallback(
    async (data: CrawlerFormSchemaType) => {
      actions.setSetting({
        ...data,
        advanced: {
          ...data.options,
        },
      })

      await asyncActions.run(data.url)
    },
    [actions, asyncActions],
  )

  const inProgressProcessId: string | null = useMemo(() => {
    return (
      Object.values(processes ?? []).find((proc) => !proc.isFinished)?.id ??
      null
    )
  }, [processes])

  return (
    <div
      className={cn(
        'bg-waves relative',
        'w-full @max-lg:h-full bg-no-repeat lg:bg-cover bg-local backdrop-opacity-60 pt-6',
        status.isAdvancedEnabled
          ? 'bg-position-[center_top_800px]'
          : 'bg-position-[center_top_200px]',
      )}
    >
      <div className={'searchContainer'}>
        <div className={cn('gradient-circle-effect', 'circleEffect fixed')} />
        <div className="flex flex-col w-full items-center justify-start py-12 max-md:px-3">
          <Header />

          <If condition={inProgressProcessId}>
            <Then>
              <Redirect
                to={`${locale}/${ClientRoutes.process}/${inProgressProcessId}`}
              />
            </Then>
            <Else>
              <div className={'searchInner'}>
                <div
                  className={cn(
                    'gradient-circle-effect z-0',
                    'circleEffectMiddle fixed',
                  )}
                ></div>
                <div className="z-2 relative w-full">
                  <CrawlerForm
                    ref={formRef}
                    onSubmit={onSubmit}
                    onError={() => {
                      actions.setMessage({
                        message: t('fields.invalid'),
                        severity: MessageSeverity.ERROR,
                      })
                    }}
                  />
                </div>
              </div>
            </Else>
          </If>
        </div>
      </div>
    </div>
  )
}
